<script setup>
import { computed } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useRightPanelResize } from 'dashboard/composables/useRightPanelResize';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { panelStyle, onResizeStart, resetPanelWidth } = useRightPanelResize();
const { width: windowWidth } = useWindowSize();

const activeTab = computed(() => {
  const { is_contact_sidebar_open: isContactSidebarOpen } = uiSettings.value;

  if (isContactSidebarOpen) {
    return 0;
  }
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  if (isSmallScreen.value && uiSettings.value?.is_contact_sidebar_open) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
      is_sage_panel_open: false,
    });
  }
};
</script>

<template>
  <div
    v-on-click-outside="() => closeContactPanel()"
    class="relative bg-n-surface-2 h-full shrink-0 flex flex-col fixed top-0 z-40 w-full md:w-auto max-w-sm md:max-w-none transition-transform duration-300 ease-in-out ltr:right-0 rtl:left-0 md:relative ltr:border-l rtl:border-r border-n-weak shadow-lg md:shadow-none"
    :class="[
      {
        'md:flex': activeTab === 0,
        'md:hidden': activeTab !== 0,
      },
    ]"
    :style="isSmallScreen ? undefined : panelStyle"
  >
    <div
      v-if="!isSmallScreen"
      class="absolute top-0 bottom-0 z-50 w-4 cursor-col-resize ltr:left-0 rtl:right-0"
      @pointerdown.stop.prevent="onResizeStart"
      @mousedown.stop.prevent="onResizeStart"
      @touchstart.stop.prevent="onResizeStart"
      @dblclick.stop="resetPanelWidth"
    >
      <div
        class="absolute top-1/2 flex h-16 w-3 -translate-y-1/2 items-center justify-center rounded-full border border-n-weak bg-n-surface-1 shadow-sm transition-colors hover:border-n-strong hover:bg-n-alpha-1 ltr:left-0.5 rtl:right-0.5"
      >
        <div class="flex flex-col gap-1">
          <span class="h-1 w-1 rounded-full bg-n-slate-10" />
          <span class="h-1 w-1 rounded-full bg-n-slate-10" />
          <span class="h-1 w-1 rounded-full bg-n-slate-10" />
        </div>
      </div>
    </div>
    <div class="flex flex-1 overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
    </div>
  </div>
</template>
